import {Grid, Stack, Typography} from "@mui/material";
import {Company} from "../../types/domain/company";
import {KeyValuePair} from "../base/KeyValuePair";
import {Address} from "../../types/domain/address";
import {useTranslation} from "react-i18next";

export interface Props {
    company?: Company;
    companyHierarchy?: Company[];
}

export const CompanyDetailsCard: React.FC<Props> = ({company, companyHierarchy}) => {
    const {t} = useTranslation();
    return (
        <Grid container spacing={3}>
            {company?.properties.name !== undefined && (
                <Grid item xs={company?.parentCompanyId ? 6 : 12}>
                    <KeyValuePair header={t("companies.details_card.name")}>
                        <Typography>{company.properties.name}</Typography>
                    </KeyValuePair>
                </Grid>
            )}
            {company?.parentCompanyId && (
                <Grid item xs={6}>
                    <KeyValuePair header={t("companies.details_card.parent")}>
                        <Typography>
                            {companyHierarchy?.find((c) => c.id === company.parentCompanyId)?.properties.name}
                        </Typography>
                    </KeyValuePair>
                </Grid>
            )}
            {company?.properties.address && (
                <Grid item xs={12}>
                    <KeyValuePair header={t("companies.details_card.address")}>
                        <CompanyAddress address={company.properties.address} />
                    </KeyValuePair>
                </Grid>
            )}
            {company?.properties.phone !== undefined && (
                <Grid item xs={12}>
                    <KeyValuePair header={t("companies.details_card.phone")}>
                        <Typography>{company.properties.phone}</Typography>
                    </KeyValuePair>
                </Grid>
            )}
            {company?.properties.vat !== undefined && (
                <Grid item xs={12}>
                    <KeyValuePair header={t("companies.details_card.vat")}>
                        <Typography>{company.properties.vat}</Typography>
                    </KeyValuePair>
                </Grid>
            )}
            {company?.properties.invoiceEmail !== undefined && (
                <Grid item xs={12}>
                    <KeyValuePair header={t("companies.details_card.invoice_email")}>
                        <Typography>{company.properties.invoiceEmail}</Typography>
                    </KeyValuePair>
                </Grid>
            )}
            {company?.isReseller !== undefined && (
                <Grid item xs={12}>
                    <KeyValuePair header={t("companies.details_card.reseller")}>
                        <Typography>
                            {company.isReseller ? t("companies.details_card.yes") : t("companies.details_card.no")}
                        </Typography>
                    </KeyValuePair>
                </Grid>
            )}
        </Grid>
    );
};

const CompanyAddress: React.FC<{address: Address}> = ({address}) => (
    <Stack direction="column">
        {address.address && <Typography>{address.address}</Typography>}
        {(address.city ?? address.state ?? address.postalCode) && (
            <Typography>
                {[address.city, address.state, address.postalCode].filter((item) => item).join(", ")}
            </Typography>
        )}
        {address.country && <Typography>{address.country}</Typography>}
    </Stack>
);
